import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, TabList, Tab, TabText, TabPanel, TabPanels } from '@tq/ui-components';

import { PastResponse, Consultation, ConsultationResponseAnswer } from 'types';
import { Notes, NotesInfoMessage } from 'components';
import { ArchivedRpcResponses } from '../ArchivedRpcResponses';
import { ArchivedResponsesDataTable } from '../ArchivedResponsesDataTable';
import { isRpc } from 'tools';

export const MobileResponses: React.FC<{
  pastResponses: PastResponse[];
  consultation?: Consultation;
  pastAnswers: ConsultationResponseAnswer[];
  otherAnswers: ConsultationResponseAnswer[];
  isLoading: boolean;
}> = ({ isLoading, pastResponses, consultation, pastAnswers, otherAnswers }) => {
  const { t } = useTranslation('consultation_response');
  const isRpcResponse = isRpc(consultation);
  const notes = consultation?.notes || [];
  return (
    <Tabs variant='line' p={0} mx={-4} data-testid='archived-responses-mobile'>
      <TabList>
        <Tab>
          <TabText>{t('responses', 'Responses')}</TabText>
        </Tab>
        <Tab>
          <TabText>{t('notes', 'Notes')}</TabText>
        </Tab>
      </TabList>
      <TabPanels py={6}>
        <TabPanel py={0} border={0}>
          {isRpcResponse ? (
            <ArchivedRpcResponses pastAnswers={pastAnswers} otherAnswers={otherAnswers} />
          ) : (
            <ArchivedResponsesDataTable
              consultationId={consultation?.id}
              pastResponses={pastResponses}
            />
          )}
        </TabPanel>
        <TabPanel py={0} border={0}>
          <NotesInfoMessage />

          <Box mt={6}>
            <Notes notes={notes} loading={isLoading} />
          </Box>
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
